import deserialize from 'app/utils/deserialize'
import { create } from 'app/utils/data'

export default {
  namespaced: true,

  state: {
    item: null
  },

  mutations: {
    resetRequestCreated(state, { resetRequest }) {
      state.item = resetRequest
    },

    resetState(state) {
      state.item = null
    }
  },

  actions: {
    async requestPasswordReset({ commit, state }, { email }) {
      const response = await create({
        url: '/api/password-reset-requests',
        type: 'password-reset-request',
        data: {
          email
        }
      })

      const resetRequest = await deserialize(response.data)

      commit('resetRequestCreated', resetRequest)

      return resetRequest
    }
  }
}
